export enum DocumentVerificationStatus {
  notChecked = 'NotChecked',
  pending = 'Pending',
  clean = 'Clean',
  warnings = 'Warnings',
  errors = 'Errors',
  unavailable = 'Unavailable',
}

export enum DocumentVerificationTrigger {
  documentsUploaded = 'DocumentsUploaded',
  documentDeleted = 'DocumentDeleted',
}

export enum VerifiedDocumentType {
  voidedCheck = 'VoidedCheck',
  application = 'Application',
  driverLicense = 'DriverLicense',
  w9 = 'W9',
}

export enum VerificationDocumentOutcome {
  extracted = 'Extracted',
  unsupportedFormat = 'UnsupportedFormat',
  documentTooLarge = 'DocumentTooLarge',
  serviceUnavailable = 'ServiceUnavailable',
  timeout = 'Timeout',
  invalidResponse = 'InvalidResponse',
  documentUnavailable = 'DocumentUnavailable',
  notExtracted = 'NotExtracted',
}

export enum VerificationVerdict {
  match = 'Match',
  mismatch = 'Mismatch',
  unverifiable = 'Unverifiable',
  documentOnly = 'DocumentOnly',
  conflict = 'Conflict',
}

export enum VerificationTargetEntity {
  client = 'Client',
  owner = 'Owner',
  bankAccount = 'BankAccount',
}

export enum DocumentMatchMethod {
  unmatched = 'Unmatched',
  name = 'Name',
  driverLicenseNumber = 'DriverLicenseNumber',
  socialSecurityNumber = 'SocialSecurityNumber',
  dateOfBirth = 'DateOfBirth',
  onlyOwner = 'OnlyOwner',
  routingAndAccountNumber = 'RoutingAndAccountNumber',
  mainAccount = 'MainAccount',
  onlyAccount = 'OnlyAccount',
}

export enum VerificationFieldKey {
  businessName = 'BusinessName',
  doingBusinessAs = 'DoingBusinessAs',
  federalTaxId = 'FederalTaxId',
  entityType = 'EntityType',
  businessStartDate = 'BusinessStartDate',
  grossAnnualIncome = 'GrossAnnualIncome',
  businessPhone = 'BusinessPhone',
  email = 'Email',
  webSite = 'WebSite',
  physicalStreet = 'PhysicalStreet',
  physicalCity = 'PhysicalCity',
  physicalState = 'PhysicalState',
  physicalZipCode = 'PhysicalZipCode',
  mailingStreet = 'MailingStreet',
  mailingCity = 'MailingCity',
  mailingState = 'MailingState',
  mailingZipCode = 'MailingZipCode',
  ownerFirstName = 'OwnerFirstName',
  ownerLastName = 'OwnerLastName',
  ownerBirthDate = 'OwnerBirthDate',
  ownerOwnership = 'OwnerOwnership',
  ownerSsn = 'OwnerSsn',
  ownerDriverLicense = 'OwnerDriverLicense',
  ownerDriverLicenseExpiration = 'OwnerDriverLicenseExpiration',
  ownerDriverLicenseState = 'OwnerDriverLicenseState',
  ownerStreet = 'OwnerStreet',
  ownerCity = 'OwnerCity',
  ownerState = 'OwnerState',
  ownerZipCode = 'OwnerZipCode',
  ownerEmail = 'OwnerEmail',
  ownerMobile = 'OwnerMobile',
  bankRoutingNumber = 'BankRoutingNumber',
  bankAccountNumber = 'BankAccountNumber',
  bankName = 'BankName',
  bankAccountName = 'BankAccountName',
}
